<template>
	<v-card :class="$vuetify.breakpoint.mdAndUp?'pa-4 mb-2':''" rounded>
		<template v-if="!!contribuyente">
			<v-card-title>
				{{titleLabel}}
				<v-spacer/>
				<v-btn fab small @click="getDatos()">
					<v-icon>refresh</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-actions>
				<v-spacer/>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn 
							color="siiNaranjo" 
							:dark="$store.getters['usuario/consultasCantidad']<3"
							v-on="on"
							@click="actualizarContribuyente"
							:block="!$vuetify.breakpoint.mdAndUp"
							:disabled="$store.getters['usuario/consultasCantidad']>=3"
						>
							<v-icon left>
								update
							</v-icon>
							Actualizar Contribuyente
							<span v-if="actualizacionesRestantes > 0">
								({{actualizacionesRestantes}})
							</span>
						</v-btn>
					</template>
					<span v-if="$store.getters['usuario/consultasCantidad']>=3">
						Se han agotado todos los actualizaciones por hoy.
					</span>
					<span v-else>
						{{actualizacionesRestantes}} actualizaciones restantes
					</span>
				</v-tooltip>
				
			</v-card-actions>
				<v-tabs
					v-model="config.tab"
					grow
				>
					<v-tab
						v-for="item in config.tabs"
						:key="item"
					>
						{{ item }}
					</v-tab>
				</v-tabs>
				<v-card-text>
				<v-tabs-items v-model="config.tab">
					<v-expand-transition>
						<v-tab-item>
							<informacion-contribuyente
								v-if="config.activo.contribuyente"
								:contribuyente="contribuyente"
							/>
						</v-tab-item>
					</v-expand-transition>
					<v-expand-transition>
						<v-tab-item>
							<sucursal
								v-if="config.activo.sucursal"
								:sucursales="sucursales"
							/>
						</v-tab-item>
					</v-expand-transition>
					<v-expand-transition>
						<v-tab-item>
								<usuario
									v-if="config.activo.usuario"
									:usuarios="usuarios"
								/>
						</v-tab-item>
					</v-expand-transition>
				</v-tabs-items>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn 
							color="siiNaranjo" 
							:dark="$store.getters['usuario/consultasCantidad']<3"
							v-on="on"
							@click="actualizarContribuyente"
							:block="!$vuetify.breakpoint.mdAndUp"
							:disabled="$store.getters['usuario/consultasCantidad']>=3"
						>
							<v-icon left>
								update
							</v-icon>
							Actualizar Contribuyente
							<span v-if="actualizacionesRestantes > 0">
								({{actualizacionesRestantes}})
							</span>
						</v-btn>
					</template>
					<span v-if="$store.getters['usuario/consultasCantidad']>=3">
						Se han agotado todos los actualizaciones por hoy.
					</span>
					<span v-else>
						{{actualizacionesRestantes}} actualizaciones restantes
					</span>
				</v-tooltip>
			</v-card-actions>
		</template>
		<v-card-text v-else-if="contribuyente === null">
			<v-alert
				border="left"
				colored-border
				color="siiNaranjo"
				elevation="2"
				type="error"
			>
				No hemos encontrado información del contribuyente {{rutContribuyente}}
			</v-alert>
		</v-card-text>
		<v-overlay :value="config.loading">
			<v-progress-circular
				indeterminate
				size="64"
			></v-progress-circular>
		</v-overlay>
		<v-dialog
			v-model="isUpdating"
			hide-overlay
			persistent
			width="300"
		>
			<v-card
				color="primary"
				dark
			>
				<v-card-title>
					Actualizando...
				</v-card-title>
				<v-card-text>
					<v-list color="transparent">
						<v-list-item >
							<v-list-item-content>
								Actualizando Contribuyente
							</v-list-item-content>
							<v-list-item-avatar>
								<v-scroll-x-transition 
									v-if="!config.actualizar.contribuyente"
									absolute
								>
									<v-icon
										color="success"
									>
										check
									</v-icon>
								</v-scroll-x-transition>
								<v-icon
									v-else
								>
									clear
								</v-icon>
							</v-list-item-avatar>
						</v-list-item>
						<v-list-item>
							<v-list-item-content>
								Actualizando Usuarios
							</v-list-item-content>
							<v-list-item-avatar>
								<v-scroll-x-transition absolute>
									<v-icon color="success" v-if="!config.actualizar.usuarios">
										check
									</v-icon>
									<v-icon v-else>
										clear
									</v-icon>
								</v-scroll-x-transition>
							</v-list-item-avatar>
						</v-list-item>
						<v-list-item>
							<v-list-item-content>
								Actualizando Sucursales
							</v-list-item-content>
							<v-list-item-avatar>
								<v-scroll-x-transition absolute>
									<v-icon color="success" v-if="!config.actualizar.sucursales">
										check
									</v-icon>
									<v-icon v-else>
										clear
									</v-icon>
								</v-scroll-x-transition>
							</v-list-item-avatar>
						</v-list-item>
					</v-list>
						</v-fade-transition>
					<v-card-actions>
						<v-progress-linear
							indeterminate
							color="white"
							class="mb-0"
						></v-progress-linear>
					</v-card-actions>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-snackbar
      v-model="alert.display"
			:color="alert.type"
    >
      {{ alert.msg }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="alert.display = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
	</v-card>
</template>

<script>

import Sucursal from './Sucursal';
import Usuario from './Usuario';
import InformacionContribuyente from './InformacionContribuyente';
import DescargadorCaf from './DescargadorCaf.vue';

import ApiManager from '@/library/utils/ApiManager';
//import API from '@aws-amplify/api';
//import Auth from '@aws-amplify/auth';

const apiSucursal = new ApiManager('eBoletaActualizador');

export default {
	name: 'AdminContribuyente',
	components:{
		InformacionContribuyente,
		Sucursal,
		Usuario
		,DescargadorCaf
	},
	data () {
		return {
			config:{
				loading: false,
				activo:{
					contribuyente: true,
					sucursal: true,
					usuario: true,
				},
				tabs:[
					'contribuyente',
					'sucursal',
					'usuario'
				],
				actualizar:{
					contribuyente: false,
					usuarios: false,
					sucursales: false
				},
				tab: 0,
			},
			alert:{
				display: false,
				msg: '',
				type: ''
			}
			,contribuyente: undefined,
			sucursales:[],
			usuarios:[],
			//contribuyenteConsultar: undefined,
		}
	},
	computed:{
		titleLabel(){

			let rut = this.contribuyente.rut;
			let dv = this.contribuyente.dv;
			let nombre = !!this.contribuyente? !!this.contribuyente.nombres? `${this.contribuyente.nombres} ${this.contribuyente.apellido_paterno} ${this.contribuyente.apellido_materno}`: '': '';
			
			let razon_social = !!this.contribuyente? this.contribuyente.razon_social|| nombre: undefined;

			if( !rut || !razon_social )
				return '';
			
			return `${rut}-${dv}  ${razon_social}`;
		},
		rutContribuyente(){

			let vm = this;
			let contribuyente = vm.$store.getters['empresas/rut'];
			contribuyente = vm.rutFormatter(contribuyente);
			return contribuyente;
		},
		isUpdating(){
			return this.config.actualizar.contribuyente || this.config.actualizar.usuarios || this.config.actualizar.sucursales;
		},
		actualizacionesRestantes(){
			return 3-this.$store.getters['usuario/consultasCantidad'];
		}
	},
	methods:{
		actualizarContribuyente: async function(evt){

			let vm = this;
			let rutContribuyente = vm.rutContribuyente;
			// actualizar contribuyente
			try{

				vm.config.actualizar.contribuyente = true;
				vm.config.actualizar.sucursales = true;
				vm.config.actualizar.usuarios = true;

				let params = {
					headers:{},
					body:{
						user: vm.$store.getters['usuario/usuario']
					}
				}

				let apiname = 'apiBoletaSII', 
					path =`/update-contribuyente-sii/${rutContribuyente}`;

				let resp = await apiSucursal.post(path, params);
				
			}catch(err){
				
				vm.config.actualizar.sucursales = false;
				vm.config.actualizar.usuarios = false;
				vm.config.actualizar.contribuyente = false;

				if( err.response.status == 500 ){
					vm.showError('Error al actualizar los datos, por favor intentelo más tarde.')
				}else{
					vm.showError(err)
				}
				
				return;
			}finally{
				vm.config.actualizar.contribuyente = false;
			}

			// actualizar sucursales y usuarios
			try{

				let params = {
					headers:{},
					body:{
						user: vm.$store.getters['usuario/usuario']
					}
				}

				let sucursalFunction = async function(){

					try{

						vm.config.actualizar.sucursales = true;

						let sucursalPath =`/update-sucursales-sii/${rutContribuyente}`;
						let resp = await apiSucursal.post(sucursalPath, params);

					}catch(err){
						
					}finally{

						vm.config.actualizar.sucursales = false;
					}
				}

				let usuarioFunction = async function(){

					try{

						vm.config.actualizar.usuarios = true;

						let userPath = `/update-usuarios-sii/${rutContribuyente}`;
						let resp = await apiSucursal.post(userPath, params);

						if( !!resp.usuarios )
							vm.checkIfUserStillInContribuyente(resp.usuarios);
					}catch(err){
						
					}finally{

						vm.config.actualizar.usuarios = false;
					}
				}

				let apiname = 'apiBoletaSII';
				
				let userPath = `/update-usuarios-sii/${rutContribuyente}`;

				let asyncCalls = [
					sucursalFunction(),
					usuarioFunction(),
				];

				let resp = await Promise.all( asyncCalls );
				vm.showSuccess('Se ha actualizado la información del contribuyente');
				vm.$store.dispatch('usuario/eventoActualizarContribuyente');

			}catch(err){
				
				throw err;
			}
		},
		getDatos: async function(){

			let vm = this;

			const contribuyente = vm.rutContribuyente;

			if( !contribuyente )
				return;

			vm.config.loading = true;

			try{

				let contribuyenteSDV = contribuyente.split('-')[0];

				let usuario = vm.$store.getters['usuario/usuario'];

				let path = `/${contribuyenteSDV}/info`;

				vm.limpiarDatos();

				let response = await apiSucursal.getCall(path);

				vm.sucursales = response.sucursales;
				vm.contribuyente = !!response.contribuyente? vm.formatVars(response.contribuyente): null;
				vm.usuarios = response.usuarios;
			}catch(err){
				
				vm.config.loading = false;
				// throw err;
			}finally{

				vm.config.loading = false;
			}
		},
		limpiarDatos: function(){
			this.sucursales = [];
			this.contribuyente = {
				rut: undefined,
				dv: undefined,
				razon_social: undefined,
				giro: undefined,
				actividad_economica: undefined,
				telefono: undefined,
				email: undefined,
				direccion: undefined,
				comuna: undefined,
				fecha_resolucion: undefined,
				numero_resolucion: undefined,
				nombres: undefined,
				apellido_paterno: undefined,
				apellido_materno: undefined,
				autoriza: undefined,
				fecha_autorizacion: undefined,
				fecha_desautorizacion: undefined,
			};
		},
		rutFormatter: function(rut) {
			if (!rut) return '';
			let str = rut.replace(/\.|-/g, '');
			return `${str.slice(0,-1)}-${str.slice(-1)}`;
		},
		formatVars: function(contribuyente){
			contribuyente.fecha_resolucion = this.fechaFormatter(contribuyente.fecha_resolucion);
			contribuyente.fecha_autorizacion = this.fechaFormatter(contribuyente.fecha_autorizacion);
			contribuyente.fecha_desautorizacion = this.fechaFormatter(contribuyente.fecha_desautorizacion);

			return contribuyente;
		},
		fechaFormatter: function(timestamp){
			if( !timestamp )	return timestamp;

			let date = new Date(timestamp);

			let formatZeroes = function(n){
				return n<10? '0'+n: n;
			}

			let yyyy = date.getUTCFullYear();
			let mm = formatZeroes(date.getUTCMonth());
			let dd = formatZeroes(date.getUTCDate());
			let hh = formatZeroes(date.getUTCHours());
			let min = formatZeroes(date.getUTCMinutes());
			let ss = formatZeroes(date.getUTCSeconds());

			return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
		},
		/*userActualEvt: function(){
			this.contribuyenteConsultar = this.rutContribuyente;
			this.getDatos();
		},*/
		showSuccess(msg){	this.showMsg('success', msg)	},
		showError(msg){	this.showMsg('error', msg)	},
		showMsg(type, msg){
			this.alert.display = true;
			this.alert.msg = msg;
			this.alert.type = type;
		},
		checkIfUserStillInContribuyente(usuarios){

			let vm = this;

			let user = vm.$store.getters['usuario/usuario']

			let isNotIn= function(){
				
				vm.$router.push({name:'NoAccess'})
			}

			if( !user )	isNotIn();
			const rutSDV = user.split('-')[0];

			if( !rutSDV )	isNotIn();

			const found = usuarios.find(({rut}) => {
				
				return rut == parseInt(rutSDV);
			});

			if( !found )	isNotIn();
		},
		async getCantidad(){

			this.$store.dispatch('usuario/getCantidadActualizacionesDiarias');
		}
	},
	mounted(){
		this.getDatos();
		this.getCantidad();
	}
}
</script>

<style lang="css" scoped>
</style>